var React = require('react');

function Email (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"x":"3","y":"5","width":"18","height":"14","rx":"1","stroke":"currentColor","strokeWidth":"2","key":0}),React.createElement("path",{"d":"M4 6L11.4 11.55C11.7556 11.8167 12.2444 11.8167 12.6 11.55L20 6","stroke":"currentColor","strokeWidth":"2","key":1})]);
}

Email.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Email;

Email.default = Email;
